<template>
  <b-container>
    <b-row id="account_dir_header">
      <b-col cols=12 md=7>
        <!-- TODO lodash debounce change -->
        <AccountDirSearch />
      </b-col>

      <b-col id="account_dir_controls" cols=12 md=5 style="text-align: right;" v-bind:class="$mq">
        <AccountDirNumPerPage v-on:change="refresh()" style="margin-right: 10px;" />
        <AccountDirSort       v-on:change="refresh()"                             />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
          <div class="spinner_container"  v-if="loading">
            <b-spinner />
          </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <AccountDirList v-bind:list="list" />
      </b-col>
    </b-row>

    <b-row v-if="enable_nav">
      <b-col style='text-align: center'>
        <AccountDirNav />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AccountDirSearch     from './account_dir/Search.vue'
import AccountDirNumPerPage from './account_dir/NumPerPage.vue'
import AccountDirSort       from './account_dir/Sort.vue'
import AccountDirList       from './account_dir/List.vue'
import AccountDirNav        from './account_dir/Nav.vue'

import config from '../config'

function get_accounts(vue){
  // return if url didn't change
  if(vue.accounts_url == vue.last_accounts_url)
    return;
  vue.last_accounts_url = vue.accounts_url;

  vue.loading = true;
  vue.list = [];
  vue.$http.get(vue.accounts_url)
           .then(function(response){
             vue.loading = false;
             vue.list = response["body"];

           // on fail try again
           }, function(){
             setTimeout(function(){ get_accounts(vue); },
                        config.RETRY_SECONDS * 1000);
           });
}

function search_accounts(vue){
  vue.loading = true;
  vue.$http.get(vue.search_url)
           .then(function(response){
             vue.loading = false;
             vue.list = response["body"];
           });
}

export default {
  name: 'AccountDir',

  components : {
    AccountDirSearch,
    AccountDirNumPerPage,
    AccountDirSort,
    AccountDirList,
    AccountDirNav
  },

  data : function(){
    return {      list : [],
               loading : true,
            enable_nav : true,
      last_accounts_url : ''};
  },

  computed : {
    page : function(){
      return this.$store.state.account.page;
    },

    num_per_page : function(){
      return this.$store.state.account.num_per_page;
    },

    sort : function(){
      return this.$store.state.account.sort;
    },

    search : function(){
      return this.$store.state.account.search;
    },

    accounts_url : function(){
      return config.DATA_URI + "/accounts/" + (this.page-1) +
                               "?num="  + this.num_per_page +
                               "&sort=" + this.sort
    },

    // TODO: multi-page search, need server side 'marker' param (also 'pages' param would help for nav)
    search_url : function(){
      return config.DATA_URI + "/accounts/search/" + this.search +
                               "?num=" + this.num_per_page;
    }
  },

  methods : {
    refresh : function(){
      get_accounts(this);
    },
  },

  watch : {
    search : function(){
      this.enable_nav = this.search == "";
      if(this.enable_nav)
        get_accounts(this);
      else
        search_accounts(this);
    }
  }
  ,
  created : function(){
    get_accounts(this);
  }
}
</script>

<style scoped>
#account_dir_header{
  background: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

  padding: 10px;
  margin-bottom: 10px;
}

#account_dir_controls.sm{
  margin-top: 10px;
  font-size: 0.7em;
}
</style>
